import { SynchTripImportDTO } from 'business/models/Models';
import React from 'react';
import { IStyle } from 'Styles';
import { csvColumnHeadings } from '../utils';

interface TableProps {
  tableData: SynchTripImportDTO[];
}

const styles: IStyle = {
  cell: {
    borderLeft: 'solid 1px Gainsboro',
    borderTop: '0px',
    whiteSpace: 'nowrap',
    lineHeight: '11px',
    fontSize: '12px',
  },

  table: {
    borderCollapse: 'collapse',
  },

  thead: {
    background: 'Gainsboro',
    position: 'sticky',
    top: 0,
    zIndex: 9999,
    borderTop: '0px',
  },

  row: { border: 'none', fontSize: '13px' },
};

function SynchTripTable({ tableData }: TableProps) {
  const columnsToDisplay = [
    'synchTripId',
    'synchTripName',
    'dataCollectionDate',
    'crystalId',
    'crystalName',
    'puckName',
    'puckPinPosition',
    'dewarId',
    'dewarName',
  ];

  const thData = () => {
    return columnsToDisplay.map((data) => {
      return (
        <th
          id={`synchtriptable-main-table-head-row-${data}`}
          style={{
            whiteSpace: 'nowrap',
          }}
          key={data}
        >
          {csvColumnHeadings[data]}
        </th>
      );
    });
  };

  const tdData = () => {
    const tableDataMap = tableData.map((trip: SynchTripImportDTO, row) => {
      return (
        <tr id={`synchtriptable-main-table-body-row-${row}`} key={row}>
          <td
            id={`synchtriptable-main-table-body-row-${trip.synchTripId}-synchtripid`}
            style={styles.cell}
          >
            {trip.synchTripId}
          </td>
          <td
            id={`synchtriptable-main-table-body-row-${trip.synchTripName}-synchtripname`}
            style={styles.cell}
          >
            {trip.synchTripName}
          </td>
          <td
            id={`synchtriptable-main-table-body-row-${trip.dataCollectionDate ? trip.dataCollectionDate.toLocaleDateString() : ''}-datacollectiondate`}
            style={styles.cell}
          >
            {trip.dataCollectionDate ? trip.dataCollectionDate.toLocaleDateString() : ''}
          </td>
          <td
            id={`synchtriptable-main-table-body-row-${trip.crystalId}-crystalid`}
            style={styles.cell}
          >
            {trip.crystalId}
          </td>
          <td
            id={`synchtriptable-main-table-body-row-${trip.crystalName}-crystalname`}
            style={styles.cell}
          >
            {trip.crystalName}
          </td>
          <td
            id={`synchtriptable-main-table-body-row-${trip.puckName}-puckname`}
            style={styles.cell}
          >
            {trip.puckName}
          </td>
          <td
            id={`synchtriptable-main-table-body-row-${trip.puckPinPosition}-puckpinposition`}
            style={styles.cell}
          >
            {trip.puckPinPosition}
          </td>
          <td
            id={`synchtriptable-main-table-body-row-${trip.dewarId}-dewarid`}
            style={styles.cell}
          >
            {trip.dewarId}
          </td>
          <td
            id={`synchtriptable-main-table-body-row-${trip.dewarName}-dewarname`}
            style={styles.cell}
          >
            {trip.dewarName}
          </td>
        </tr>
      );
    });

    return tableDataMap;
  };

  return (
    <table id="synchtriptable-main-table" className="table" style={styles.table}>
      <thead id="synchtriptable-main-table-head" style={styles.thead}>
        <tr id="synchtriptable-main-table-head-row" style={styles.row}>
          {thData()}
        </tr>
      </thead>
      {tableData.length && <tbody id="synchtriptable-main-table-body">{tdData()}</tbody>}
    </table>
  );
}
export default SynchTripTable;
